import { ValidationError } from "sequelize"
import {
    MarkovGroup,
    MarkovGroupCreate,
    MarkovGroupSave,
} from "server/models"
import { OrderType } from "client/utils"
import {
    GET, POST, DELETE, sort, search, validate,
} from "client/store/utils"
import { LangType } from "client/store"
import {
    MarkovGroupList,
    MarkovGroupFilters,
    MarkovGroupValidation,
} from "./types"


export const LoadAllMarkovGroups = (modelId: number) => (
    GET(`/markovGroup/modelId/${modelId}`)
    .then((groups: MarkovGroup[]) => {
        const groupList: MarkovGroupList = {}
        groups.forEach((group) => {
            groupList[group.id] = group
        })
        return groupList
    })
)

export const LoadMarkovGroupById = (groupId: number, modelId: number) => (
    GET(`/markovGroup/id/${groupId}/modelId/${modelId}`)
    .then((group: MarkovGroup) => group)
)

export const SaveMarkovGroup = (
    id: number,
    group: MarkovGroupCreate,
    lang: LangType,
) => {
    const data: MarkovGroupSave = {
        id,
        group,
    }
    return POST(
        "/markovGroup/save",
        JSON.stringify(data),
    ).then((res) => {
        const newGroup = res as MarkovGroup
        const error = res as ValidationError

        return {
            newGroupId: newGroup.id || null,
            validation: <MarkovGroupValidation>validate(error, lang),
        }
    })
}

export const DeleteMarkovGroup = (groupId: number, modelId: number) => (
    DELETE(`/markovGroup/delete/${groupId}/${modelId}`)
    .then((removedRows: number) => removedRows)
)

export const SortMarkovGroups = (
    groups: MarkovGroup[],
    sortColumn: keyof MarkovGroup,
    sortOrder: OrderType,
    filters: MarkovGroupFilters,
) => {
    const groupsFiltered = groups.filter((group) => {
        let showRow = true
        if (filters.search) showRow = search(filters.search, group)
        return showRow
    })
    groupsFiltered.sort((a, b) => sort(a, b, sortColumn, sortOrder))

    const groupIds: number[] = []
    groupsFiltered.forEach((group) => groupIds.push(group.id))

    return groupIds
}
